var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 shadow",attrs:{"role":"alert"}},[_c('p',{staticClass:"font-semibold mb-2"},[_vm._t("text")],2),_c('p',{staticClass:"text-sm"},[_vm._t("description")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }